<template>
  <v-dialog v-model="dialog" width="1000">
    <EditarHorarioEspecial />
    <v-card>
      <v-card-title class="headline">
        <v-icon>event_note</v-icon>
        Ver horarios especiales
        <v-spacer></v-spacer>

        <v-btn @click="close()" icon>
          <v-icon>clear</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="lista_horarios_especiales"
          class="elevation-1"
          :disable-initial-sort="true"
        >
          <template v-slot:items="props">
            <td class="text-xs-center">
              {{ props.item.fecha_creacion }}
            </td>
            <td class="text-xs-center">
              {{ props.item.descripcion }} -{{ props.item.detalle }}
            </td>
            <td class="text-xs-center">
              {{ props.item.tipo_horario }}
            </td>

            <td>
              <v-edit-dialog
                :return-value.sync="props.item.fecha_desde"
                lazy
                @save="save(props.item)"
                @cancel="cancel_horario_esp"
                @open="open_horario_esp"
                @close="close_horario_esp"
              >
                {{ props.item.fecha_desde }}
                <template v-slot:input>
                  <v-text-field
                    type="date"
                    v-model="props.item.fecha_desde"
                    :rules="[
                      v => {
                        if (v > props.item.fecha_hasta) {
                          return `Introduzcca una fecha menor o igual a ${props.item.fecha_hasta}`;
                        }
                        return true;
                      }
                    ]"
                    label=""
                    single-line
                    autofocus
                  ></v-text-field>
                </template>
              </v-edit-dialog>
            </td>
            <!--:rules="[
                      
                      (v) => {
                        if (v < props.item.fecha_desde) {
                          return `Introduzcca una fecha mayor o igual a ${props.item.fecha_desde}`;
                        }
                        return true;
                      },
                    ]"-->
            <td>
              <v-edit-dialog
                :return-value.sync="props.item.fecha_hasta"
                lazy
                @save="save(props.item)"
                @cancel="cancel_horario_esp"
                @open="open_horario_esp"
                @close="close_horario_esp"
              >
                {{ props.item.fecha_hasta }}
                <template v-slot:input>
                  <v-text-field
                    type="date"
                    v-model="props.item.fecha_hasta"
                    label=""
                    single-line
                    autofocus
                  ></v-text-field>
                </template>
              </v-edit-dialog>
            </td>
            <td class="text-xs-center">
              {{ props.item.estado }}
            </td>
            <td class="text-xs-center">
              <v-tooltip bottom>
                <v-btn
                  color="red"
                  @click="eliminarHorarioEspecial(props.item)"
                  dark
                  icon
                  slot="activator"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
                <span>Eliminar</span>
              </v-tooltip>
              <v-tooltip bottom>
                <v-btn
                  color="rgb(255,179,0)"
                  @click="editarHorarioEspecial(props.item)"
                  icon
                  slot="activator"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
                <span>Editar fechas</span>
              </v-tooltip>
              <v-tooltip bottom>
                <v-btn
                  color="indigo"
                  @click="verDetalleHorarioEspecial(props.item)"
                  dark
                  icon
                  slot="activator"
                >
                  <v-icon>visibility</v-icon>
                </v-btn>
                <span>Ver detalle</span>
              </v-tooltip>
              <!-- <v-menu
                v-model="props.item.menu"
                :close-on-content-click="false"
                :nudge-width="350"
                offset-x
                left
              >
                <template v-slot:activator="{ on }">
                  
                </template>
              </v-menu> -->
            </td>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click.native="close()">
          <v-icon>cancel</v-icon> {{ $t("common.cancel") }}
        </v-btn>
      </v-card-actions>
    </v-card>
    <!-- DIALOG DETALLE-->
    <v-dialog v-model="dialog_detalle" width="600">
      <v-card>
        <v-card-title class="headline">
          <v-icon>event_note</v-icon>
          Detalle de horario
          <v-spacer></v-spacer>
          <v-btn @click="closeDialogDetalle()" icon>
            <v-icon>clear</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs4 class="text-xs-center"
              ><b>Horario especial: </b>{{ form.descripcion }}</v-flex
            >
            <v-flex xs4 class="text-xs-center"
              ><b>Fecha desde: </b>{{ form.fecha_desde }}</v-flex
            >
            <v-flex xs4 class="text-xs-center"
              ><b>Fecha hasta: </b>{{ form.fecha_hasta }}</v-flex
            >
            <v-flex xs12>
              <v-data-table
                :headers="headers_detalle_horario"
                :items="lista_horarios_detalle"
                class="elevation-1"
                :disable-initial-sort="true"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ props.item.dia }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.hora_entrada }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.hora_salida }}
                  </td>

                  <td class="text-xs-center"></td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones
import { parse } from "json5";
import EditarHorarioEspecial from "./EditarFechasHorarioEsp.vue";
export default {
  mixins: [validate],
  components: {
    EditarHorarioEspecial,
  },
  data() {
    return {
      dialog: false,
      loading: false,
      valid: true,
      horario: {},
      horarios_especiales: [],
      lista_horarios_especiales: [],
      lista_horarios_detalle: [],
      id_persona: null,
      form: {},
      dias: [],
      user: this.$storage.get("user"),
      dialog_detalle: false,
      //variables del campo editable de tabla
      snack: false,
      snackColor: "",
      snackText: "",

      headers_detalle_horario: [
        {
          text: "Día",
          value: "dia",
          align: "center",
        },
        { text: "Hora ingreso", value: "hora_entrada", align: "center" },
        { text: "Hora salida", value: "hora_salida", align: "center" },
      ],
      headers: [
        { text: "Fecha registro", value: "fecha_registro", align: "center" },
        {
          text: "Horario especial",
          value: "descripcion",
          align: "center",
        },
        { text: "Tipo horario", value: "tipo_horario", align: "center" },

        { text: "Fecha desde", value: "fecha_desde", align: "center" },
        { text: "Fecha hasta", value: "fecha_hasta", align: "center" },
        { text: "Estado", value: "estado", align: "center" },
        { text: "Acciones", value: "", align: "center" },
      ],
      horarios_cargados: [],
    };
  },
  async mounted() {
    this.$bus.$on("openDialogVerHorarioEspecial", async (item) => {
      this.horario = item;
      await this.obtenerHorariosEspeciales();
      await this.obtenerDias();
      this.id_persona = parseInt(item.id);
      this.dialog = true;
      this.$bus.$on("closeDialogEditarFechasHorEsp", async() => {
      await this.obtenerHorariosEspeciales();
      await this.obtenerDias();
    });
    });
  },
  methods: {
    // Metodo pare cerrar el dialog del detalle
    closeDialogDetalle() {
      this.dialog_detalle = false;
      this.form = {};
    },
    //metodo para editar fechas:
    async save(item) {
      console.log(item);
      try {
        this.snack = true;
        this.snackColor = "success";
        this.snackText = "Data saved";
        if (item.fecha_desde <= item.fecha_hasta) {
          let respuesta = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta:"select control.fn_modifica_horario_especial_fechas(${parseInt(
                  this.user.id
                )},'${item.fecha_desde}','${item.fecha_hasta}',${parseInt(
              item.id_persona
            )},${parseInt(item.grupo)})"){
                  respuesta
                }
              }
            `,
          });
          respuesta =
            respuesta.runQuery.respuesta[0].fn_modifica_horario_especial_fechas.split(
              "|"
            );
          if (respuesta[0] == "1") {
            this.$message.success("Modificación exitosa");
          }
          await this.obtenerHorariosEspeciales();
          await this.obtenerDias();
        }
      } catch (error) {
        console.log(error);
      }
    },
    //metodo para editar fechas-dialog close:
    cancel_horario_esp() {
      this.snack = true;
      this.snackColor = "error";
      this.snackText = "Canceled";
    },
    open_horario_esp() {
      this.snack = true;
      this.snackColor = "info";
      this.snackText = "Dialog opened";
    },
    close_horario_esp() {
      console.log("Dialog closed");
    },
    // Metoodo para elminar el detalle
    async eliminarHorarioEspecial(item) {
      this.$confirm("¿Está seguro de eliminar el registro?", async () => {
        try {
          let respuesta = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta:"select control.fn_elimina_horario_especial(${parseInt(
                  item.grupo
                )},${parseInt(this.user.id)})"){
                  respuesta
                }
              }
            `,
          });
          respuesta =
            respuesta.runQuery.respuesta[0].fn_elimina_horario_especial.split(
              "|"
            );
          if (respuesta[0] == "1") {
            this.$message.success(respuesta[1]);
          } else {
            this.$message.warning(respuesta);
          }
          await this.obtenerHorariosEspeciales();
        } catch (error) {
          console.log(error);
        }
      });
    },
    close() {
      this.loading = false;
      this.horario = {};
      this.form = {};
      (this.horarios_cargados = []), (this.dialog = false);
    },

    obtieneNombreHorarioEspecial(id) {
      const found = this.horarios_especiales.find(
        (element) => element.id == parseInt(id)
      );
      return found.descripcion;
    },
    obtieneNombreDia(id) {
      const found = this.dias.find((element) => element.id == parseInt(id));
      return found.valor.split("-")[1];
    },
    async obtenerHorariosEspeciales() {
      try {
        let respuesta = await this.$service.graphql({
          query: `
            query{
                  runQuery(consulta:"select * FROM control.v_horario_especial_general WHERE id_persona=${parseInt(
                    this.horario.id
                  )} and id_estado=1 order by (fecha_desde::date) desc"){
                  respuesta
                  }
                }
            `,
        });
        let lista_tmp = respuesta.runQuery.respuesta;
        this.lista_horarios_especiales = lista_tmp;
      } catch (error) {
        console.log(error);
      }
    },
    async verDetalleHorarioEspecial(item) {
      try {
        this.dialog_detalle = true;
        this.form.fecha_desde = item.fecha_desde;
        this.form.fecha_hasta = item.fecha_hasta;
        this.form.descripcion = item.descripcion;

        let respuesta = await this.$service.graphql({
          query: `
            query{
                  runQuery(consulta:"SELECT * FROM control.v_horario_especial_detalle WHERE id_persona = ${parseInt(
                    this.horario.id
                  )} AND grupo = ${item.grupo}"){
                  respuesta
                  }
                }
            `,
        });
        this.lista_horarios_detalle = respuesta.runQuery.respuesta;
      } catch (error) {
        console.log(error);
        this.dialog_detalle = false;
      }
    },
    async obtenerDias() {
      try {
        let res = await this.$service.graphql({
          query: `
            query{
              params(tipo: "dia"){
                rows{
                  id
                  valor
                }
              }
            }
          `,
        });
        this.dias = res.params.rows;
      } catch (error) {
        console.log(error);
      }
    },
    editarHorarioEspecial(item) {
      this.$bus.$emit("openDialogEditarFechasHorarioEsp", item);
    },

    // async save() {
    //   this.loading = true;
    //   try {
    //     this.horario.horario_personas.forEach((item) => {
    //       this.horarios_cargados.forEach(async (elem) => {
    //         let data = {
    //           id_horario_persona: parseInt(item.id),
    //           hora_inicio: elem.hora_inicio,
    //           hora_fin: elem.hora_fin,
    //           id_estado: 1,
    //           id_parametro_dia: parseInt(elem.id_parametro_dia),
    //           fecha_desde: elem.fecha_desde,
    //           fecha_hasta: elem.fecha_hasta,
    //           id_horario_especial: parseInt(elem.id_horario_especial),
    //         };
    //         let res = await this.$service.graphql({
    //           query: `
    //             mutation add($persona_horario_dias: NewPersonaHorarioDias!){
    //               personaHorarioDiasAdd(persona_horario_dias: $persona_horario_dias){
    //                 id
    //               }
    //             }
    //           `,
    //           variables: {
    //             persona_horario_dias: data,
    //           },
    //         });
    //       });
    //     });
    //     this.$message.success();
    //     this.close();
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/asignacion_horario/dialogs/VerHorarioEspecial.vue